import React, { useEffect, useState } from "react";
import axiosConfig from "../../axiosConfig";
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import { Grid } from "@material-ui/core";
import AddBox from "@material-ui/icons/AddBox";
import { tableIcons } from "../../shared/TableIcons";
import Edit from "@material-ui/icons/Edit";
import Check from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import Swal from "sweetalert2";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import { makeStyles } from "@material-ui/core/styles";
import exportCSV from "../../services/exportCSV";
import exportPDF from "../../services/exportPDF";
import { swalSubmit } from "../../shared/swalSubmit";

const useStyles = makeStyles(styles);

function ManagementUsers() {
  const history = useHistory();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const classes = useStyles();

  useEffect(() => {
    refreshList();
  }, []);

  const refreshList = () => {
    axiosConfig.get("/User/GetAllUsers")
      .then((res) => {
        setUsers(res.data);
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  for (let i = 0; i < users.length; i++) {
    if (users[i].isActive === true) {
      users[i].status = "Ενεργή";
    } else {
      users[i].status = "Ανενεργή";
    }
  }


  const handleToggleStatusClick = (selected, status, username) => {
    Swal.fire({
      title: "",
      text: `Έχετε επιλέξει να απενεργοποιήσετε τον Χειριστή με username ${username}.Είστε βέβαιοι;`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ναι",
      cancelButtonText: "Οχι",
      showLoaderOnConfirm: true,
      closeOnClickOutside: false,
      preConfirm: () => {
        Swal.fire(swalSubmit).then((result) => {
          if (result.isConfirmed) {
            return axiosConfig
              .put(`/User/ToggleUserStatus`, {
                userId: selected,
                isActive: !status,
              })
              .then((res) => {
                if (res.status === 200) {
                  refreshList();
                }
              })
              .catch((err) => {
                Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
              })
          }
        })

      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  return (
    <Grid item xs={12} style={{ marginTop: "16px" }}>
      <Card>
        <CardHeader color="warning">
          <h1 className={classes.cardTitleWhite}>Χειριστές συστήματος</h1>
        </CardHeader>
        <CardBody>
          <MaterialTable
            icons={tableIcons}
            isLoading={isLoading}
            title=""
            columns={[
              {
                title: "Email",
                field: "email",
              },
              {
                title: "Όνομα",
                field: "firstname",
              },
              { title: "Επώνυμο", field: "lastname" },
              {
                title: "Ρόλος",
                field: "role",
              },
              {
                title: "Κατάσταση",
                field: "status",
              },
            ]}
            data={users}
            actions={[
              {
                icon: () => <AddBox />,
                onClick: () => {
                  history.push("/create-user");
                },
                isFreeAction: true,
                tooltip: "Προσθήκη",
              },
              {
                icon: () => <Edit />,
                tooltip: "Επεξεργασία/Λεπτομέρειες",
                onClick: (e, row) => {
                  history.push({
                    pathname: "/edit-management-user",
                    selected: row.id,
                  });
                },
              },
              (rowData) => ({
                icon: () => (rowData.isActive === true ? <Clear /> : <Check />),
                tooltip:
                  rowData.isActive === true ? "Απενεργοποίηση" : "Ενεργοποίηση",
                onClick: (e, row) => {
                  handleToggleStatusClick(row.id, row.isActive, row.email);
                },
              }),
            ]}
            localization={{
              body: {
                emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
                filterRow: {
                  filterTooltip: 'Φίλτρο',
                  filterPlaceHolder: 'Αναζήτηση'
                }
              },
              toolbar: {
                showColumnsTitle: "Δείξτε κολώνες",
                addTooltip: "Προσθήκη",
                searchTooltip: "Αναζήτηση",
                searchPlaceholder: "Αναζήτηση",
                exportTitle: "Εξαγωγή",
                exportCSVName: "Εξαγωγή σε CSV",
                exportPDFName: "Εξαγωγή σε PDF",
              },
              pagination: {
                firstTooltip: "Πρώτη Σελίδα",
                lastTooltip: "Τελευταία Σελίδα",
                previousTooltip: "Προηγούμενη Σελίδα",
                nextTooltip: "Επόμενη Σελίδα",
                labelDisplayedRows: "{from}-{to} από {count}",
                labelRowsSelect: "Εγγραφές ανά Σελίδα",
              },
              grouping: {
                placeholder: "Σύρετε για να ομαδοποιήσετε",
                groupedBy: "Σύρετε για να ομαδοποιήσετε",
              },
              header: {
                actions: "Ενέργειες",
              },
            }}
            options={{
              searchFieldAlignment: "left",
              pageSize: 10,
              pageSizeOptions: [10, 15, 20],
              columnsButton: true,
              exportButton: true,
              exportPdf: (columns, data) => {
                exportPDF(columns, data);
              },
              exportCsv: (columns, data) => {
                exportCSV(columns, data);
              },
              grouping: false,
              search: false,
              sorting: true,
              filtering: true,
              exportAllData: true,
            }}
          />
        </CardBody>
      </Card>
    </Grid>
  );
}

export default ManagementUsers;
